import { useTranslation } from 'react-i18next';
import { Heading, Paragraph } from '@digdir/designsystemet-react';

import useRegistrationForm from '../../../../screens/registration/useRegistrationForm';
import { useEnergyAnalysis } from '../../../../hooks/useEnergyAnalysis';
import { PageWrapper } from '../solceller';

import { VisningOgDelingsFrom } from './form/visningsogdelingsform';

export const VisningOgDeling = () => {
  const { t } = useTranslation('', { keyPrefix: 'form' });
  const { registrationId } = useRegistrationForm();
  const { energyAnalysis } = useEnergyAnalysis(registrationId);

  if (!energyAnalysis?.energiplan || !registrationId) {
    return null;
  }

  return (
    <PageWrapper>
      <Heading level={1} data-size="lg">
        {t('samtykke.pageTitle')}
      </Heading>
      <Paragraph className="text-preline" data-size="sm">
        {t('samtykke.info')}
      </Paragraph>
      <VisningOgDelingsFrom registrationId={registrationId} energianalyse={energyAnalysis} />
    </PageWrapper>
  );
};
